import { Component } from '@angular/core';
import { BaseComponentContext } from '../../../../modules/tcm-core.module';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { ClinicDataService } from '../../../../services';
import { UpdateClinicLogoRequest } from '../../../../models/clinics/update-clinic-logo-request';

@Component({
    selector: 'update-clinic-logo',
    templateUrl: './update-clinic-logo.component.html',
    styleUrls: ['./update-clinic-logo.component.scss'],
    standalone: false
})
export class UpdateClinicLogoComponent {
  public requestModel: any;

  public isLoading: boolean;

  public base64img: string;

  public constructor(private componentContext: BaseComponentContext, private clinicDataService: ClinicDataService) {
  }

  goBack(data?: any) {
    this.componentContext.navService.navigateBack(data);
  }

  public async save() {
    if (this.base64img) {
      var request = {} as UpdateClinicLogoRequest;

      request.clinicId = this.requestModel.clinicId;
      request.base64string = this.resizeImage(this.base64img);

      try {
        this.isLoading = true;
        await this.clinicDataService.updateClinicLogoAsync(request);
      }
      finally {
        this.isLoading = false;
      }

      this.componentContext.broadcastService.next({ name: BroadCastEvents.ClinicLogoChanged, args: { src: this.base64img } });
      this.goBack();
    }
  }

  public onPictureLoaded(args: any) {
    this.base64img = args.base64string;
  }
  
  public resizeImage(base64Str) {
    var img = new Image();
      img.src = base64Str;
      var canvas = document.createElement('canvas');
      var MAX_WIDTH = 400;
      var MAX_HEIGHT = 350;
      var width = img.width;
      var height = img.height;
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      return canvas.toDataURL();
  }
}
